/* eslint-disable prettier/prettier */
import React from "react";

export default function ColorBar() {
  return (
    <div
      style={{
        display: "flex",
      }}
    >
      <div
        style={{
          backgroundColor: "#043D90",
          width: "30%",
          height: "3px",
          transform: "skewX(40deg)",
          marginLeft: "12px",
        }}
      >
        {" "}
      </div>
      <div
        style={{
          backgroundColor: "#FFFF00",
          width: "30%",
          height: "3px",
          transform: "skewX(40deg)",
          marginLeft: "12px",
        }}
      >
        {" "}
      </div>
      <div
        style={{
          backgroundColor: "#FF0100",
          width: "40%",
          height: "3px",
          transform: "skewX(40deg)",
          marginLeft: "12px",
        }}
      >
        {" "}
      </div>
      {/* <div
        style={{
          borderBottom: "#FF0100 3px solid",
          width: "25%",
          height: "5px",
          transform: "skewX(40deg)",
        }}
      >
        {" "}
      </div> */}
    </div>
  );
}
